var serviceWorker = {
  controller: 'ServiceWorkerController'
};

angular
  .module('common.sw')
  .component('serviceWorker', serviceWorker);